import React from 'react';
import cn from 'classnames';

import css from 'styles/components/search/savedSearch.scss';

const SavedSearch = ({ additionalClass = null, heartActive, handleSavedSearch }) => <button type="button" onClick={handleSavedSearch} className={cn(additionalClass, css.savedSearch, { [css.heartActive]: heartActive })}>{heartActive ? 'Unsave' : 'Save'} Search</button>;

export default SavedSearch;
